var map = {
	"./01-convert-binary-short-name-setting.js": 414,
	"./02-store-settings-in-overlayplugin.js": 415,
	"./03-convert-light-theme.js": 416,
	"./04-convert-spell-layout.js": 417,
	"./05-copy-spell-tts.js": 418,
	"./06-change-critical-hp-setting-key.js": 419,
	"./07-convert-auto-hide-to-options.js": 420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 413;